import { ArrowsAltOutlined } from "@ant-design/icons";
import { Col, Row, Typography, InputNumber, Space } from "antd";
import React, { useState } from "react";
import KnivesTable from "./KnivesTable";

const { Text } = Typography;

export default function KnivesSearch() {
   const [minWidth, setMinWidth] = useState();
   const [minHeight, setMinHeight] = useState();
   const [maxWidth, setMaxWidth] = useState();
   const [maxHeight, setMaxHeight] = useState();

   return (
      <div>
         <Row gutter={[10, 10]}>
            {/* ### MINIMAL APPROX WIDTH */}
            <Col span={12}>
               <Space>
                  <ArrowsAltOutlined rotate={45} style={{ color: "#f5222d", fontSize: "22px", verticalAlign: "middle", paddingBottom: "2px" }} />
                  <Text>Min Width</Text>
               </Space>
               <InputNumber style={{ width: "100%" }} min={0} className="input-style" value={minWidth} onChange={setMinWidth} />
            </Col>
            {/* ### MINIMAL APPROX HEIGHT */}
            <Col span={12}>
               <Space>
                  <ArrowsAltOutlined rotate={135} style={{ color: "#f5222d", fontSize: "22px" }} />
                  <Text>Min Height</Text>
               </Space>

               <InputNumber style={{ width: "100%" }} min={0} className="input-style" value={minHeight} onChange={setMinHeight} />
            </Col>
            {/* ### MAXIMUM APPROX WIDTH */}
            <Col span={12}>
               <Space>
                  <ArrowsAltOutlined rotate={45} style={{ color: "#f5222d", fontSize: "22px", verticalAlign: "middle", paddingBottom: "2px" }} />
                  <Text>Max Width</Text>
               </Space>

               <InputNumber style={{ width: "100%" }} min={minWidth + 1} max={minWidth + 10} className="input-style" value={maxWidth} onChange={setMaxWidth} />
            </Col>
            {/* ### MAXIMUM APPROX HEIGHT */}
            <Col span={12}>
               <Space>
                  <ArrowsAltOutlined rotate={135} style={{ color: "#f5222d", fontSize: "22px", verticalAlign: "middle", paddingBottom: "2px" }} />
                  <Text>Max Height</Text>
               </Space>

               <InputNumber
                  style={{ width: "100%" }}
                  min={minHeight + 1}
                  max={minHeight + 10}
                  className="input-style"
                  value={maxHeight}
                  onChange={setMaxHeight}
               />
            </Col>
         </Row>
         <Row>
            <Col span={24}>
               <KnivesTable minWidth={minWidth} maxWidth={maxWidth} minHeight={minHeight} maxHeight={maxHeight} />
            </Col>
         </Row>
      </div>
   );
}
